import React from 'react'

import FieldLabel from '@react/react-spectrum/FieldLabel'

import MediaUpload from 'components/MediaUpload'
import { RichTextFormField } from 'components/RichTextEditor'
import { ScreenPicker } from '../../ScreenPicker'

const Blog = ({ screen, project, disabled, onChange }) => {
  const content = screen?.content
  return (
    <>
      <FieldLabel label='Summary'>
        <RichTextFormField
          label='Page Summary'
          value={content.subtitle || ''}
          onChange={onChange('subtitle')}
          disabled={disabled}
        />
      </FieldLabel>

      <FieldLabel label='Image' labelFor='image'>
        <MediaUpload
          type='image'
          value={content.image || ''}
          maxHeight='100px'
          onUpload={onChange('image')}
          projectId={project?.meta?.id}
          path={`blog-${screen?.meta?.name}-image`}
          withTextfield={true}
          disabled={disabled}
        />
      </FieldLabel>
    </>
  )
}

const ChildScreens = ({ screen, disabled, onChange }) => {
  const content = screen?.content
  return (
    <ScreenPicker
      screenName={screen?.meta?.name}
      screens={content.list}
      onChange={onChange('list')}
      disabled={disabled}
      multiple
    />
  )
}

export default [
  { label: 'Blog', content: Blog },
  { label: 'Child Screens', content: ChildScreens },
]
